//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
let d=[[],[[["trim_corner"],"CreateTrimCornerBuilder",{R_:{builder:"Features.TrimCornerBuilder"}},1,0],[["divide_curve"],"CreateDivideCurveBuilder",{R_:{builder:"Features.DivideCurveBuilder"}},1,0],[["associative_line"],"CreateAssociativeLineBuilder",{R_:{builder:"Features.AssociativeLineBuilder"}},1,0],[["non_associative_line"],"CreateAssociativeLineBuilderFromNonAssociativeLine",{R_:{builder:"Features.AssociativeLineBuilder"}},1,0],[["associative_arc"],"CreateAssociativeArcBuilder",{R_:{builder:"Features.AssociativeArcBuilder"}},1,0],[["non_associative_arc"],"CreateAssociativeArcBuilderFromNonAssociativeArc",{R_:{builder:"Features.AssociativeArcBuilder"}},1,0],[["point"],"CreatePointFeatureBuilder",{R_:{builder:"Features.PointFeatureBuilder"}},1,0],[["wavelink"],"CreateWaveLinkBuilder",{R_:{builder:"Features.WaveLinkBuilder"}},1,0],[["wave_interface_linker"],"CreateWaveInterfaceLinkerBuilder",{R_:{builder:"Features.WaveInterfaceLinkerBuilder"}},1,0],[["move_object"],"CreateMoveObjectBuilder",{R_:{builder:"Features.MoveObjectBuilder"}},1,0]],[]];
SPLM.Features.BaseFeatureCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.BaseFeatureCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;